import { useCallback, useState } from 'react';

import { RotateCcw } from 'lucide-react';
import { LoadingSpinner, DefaultTooltip } from 'twyne-new.ui'

import { useGrid } from '@Components/Grid';
import { getInfo, keyOf } from '@Components/Grid/components/Table/formatters';

export default function RetryFormatter({ info }) {
  const { events: { handleRetry } } = useGrid()

  const [retrying, setRetrying] = useState(false)

  const { row } = getInfo(info)
  const { id } = row

  const targetId = keyOf(info, 'retry')

  const handleClick = useCallback(async () => {
    setRetrying(true)
    await handleRetry(id)
    setRetrying(false)
  }, [handleRetry, id])

  return <>
    <DefaultTooltip content='Retry' side='left'>
      <span id={targetId} className="action" onClick={handleClick}>
        {retrying ? <LoadingSpinner width={16} height={16} /> : <RotateCcw size={16} />}
      </span>
    </DefaultTooltip>
  </>
}
